<template>
  <div class="card card-plain">
    <div v-if="store.state.alert.message" class="card-header pt-0">
      <argon-alert 
        v-show="store.state.alert.type == 'danger'"
        class="mb-0 text-sm text-center" 
        :color="store.state.alert.type"
      >
        {{ store.state.alert.message }}
      </argon-alert>
    </div>
    <div class="card-body py-0 cropper-body">
      <div class="mb-3">
        <input
          class="form-control"
          type="file"
          accept="image/*"
          ref="file"
          @change="getUploadedImage"
        >
      </div>
      <div class="mb-2">
        <div v-if="imgLoading" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <Cropper
          ref="cropper"
          class="reg-cropper"
          @ready="ready"
          @error="error"
          :src="uploadedImg"
          :stencil-props="{
            aspectRatio: 1,
            movable: false,
            resizable: false,
          }"
          :stencil-size="{
            width: 220,
            height: 220
          }"
          :resize-image="{
            touch: true,
            wheel: true,
            adjustStencil: false,
          }"
          :move-image="{
            mouse: true,
            touch: true,
          }"
          :auto-zoom="true"
          image-restriction="stencil"
        />
      </div>
    </div>
    <div class="card-footer pb-0 text-end">
      <button
        type="button" 
        class="btn btn-primary me-3"
        @click="crop"
      >
        <span class="indicator-label"> Uložit </span>
      </button>
      <button 
        type="button" 
        class="btn btn-outline-primary"
        @click="store.dispatch('closeModal')"
      >
        Storno
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, watch, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import ArgonAlert from '@/components/ArgonAlert.vue';

const emit = defineEmits(['cropped-img-data'])

const store = useStore();

const file = ref();
const cropper = ref();

const imgLoading = ref(false);
const uploadedImg = ref(null);
const croppedImgData = reactive({
  imgUrl: null,
  coordinates: {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
  }
})

const getUploadedImage = (e) => {
  const file = e.target.files[0];
  if (file) { 
    // revoke object URL
    if (uploadedImg.value) { 
      URL.revokeObjectURL(uploadedImg.value); 
    }
    // create the blob link to the file
    uploadedImg.value = URL.createObjectURL(file); 
  } 
}
const crop = () => {
  if (uploadedImg.value) {
    const { coordinates, canvas } = cropper.value.getResult();

    croppedImgData.coordinates = coordinates;
    croppedImgData.imgUrl = canvas.toDataURL('image/jpeg', 0.5);

    emit('cropped-img-data', croppedImgData);
    store.dispatch('closeModal'); 
  } else {
    store.dispatch('alertError', 'Nahraj profilovou fotku')
  }
}
const ready = () => {
  imgLoading.value = false;
};
const error = () => {
  console.log('There is error during image loading');
  imgLoading.value = false;
};

watch(uploadedImg, (value) => {
  if (value) { 
    imgLoading.value = true; 
  }
});
onUnmounted(() => {
  if (uploadedImg.value) { 
    URL.revokeObjectURL(uploadedImg.value);
  }
});

</script>
<style scoped>
.cropper-body :deep(.vue-advanced-cropper) {
  max-width: 100%;
  height: 280px !important;
  max-height: 280px;
}
.cropper-body :deep(.vue-advanced-cropper__background),
.cropper-body :deep(.vue-advanced-cropper__foreground),
.cropper-body :deep(.vue-advanced-cropper__image-wrapper) {
  cursor: grab;
}
.cropper-body :deep(.vue-advanced-cropper--moving) {
  cursor: grabbing;
}
</style>